// extracted by css-extract-rspack-plugin
export default {"container":"CompactContainer-module__container__qOx8a","comments":"CompactContainer-module__comments__X3cqB"};